var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgBrDocumentHome = function SvgBrDocumentHome(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 33,
    viewBox: "0 0 35 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_308_2894)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.874957 0.677781L34.4161 0.675781V19.6762H32.3176L32.3186 2.67572L2.95253 2.67672V23.6761L13.4401 23.6751V25.6741L0.856079 25.6751L0.874957 0.677781ZM6.112 5.67704L29.172 5.67604L29.1594 7.67499L6.09942 7.67599L6.112 5.67704ZM29.1597 13.6748L29.1723 11.6759L6.11127 11.6769L6.09973 13.6758L29.1597 13.6748ZM15.5329 19.6746L6.09942 19.6756L6.10466 17.6767L15.5382 17.6757L15.5329 19.6746Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5237 23.8281L17.6364 25.5241L19.1781 24.6061V32.6761H31.7635V24.6061L33.3042 25.5241L34.4169 23.8281L25.4698 18.4961L16.5237 23.8281ZM21.2757 23.3551L25.4698 20.8551L29.6659 23.3551V30.6761H21.2757V23.3551Z",
    fill: "#0157FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_308_2894"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.561,
    height: 32,
    fill: "white",
    transform: "translate(0.855469 0.675781)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBrDocumentHome);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "br_document_home.5a096d57fd28f21703a587c062abc412.svg";